import { render, staticRenderFns } from "./LoyaltyTierList.vue?vue&type=template&id=160593b2&"
import script from "./LoyaltyTierList.vue?vue&type=script&lang=js&"
export * from "./LoyaltyTierList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports